import {
  sendCustomerRequest
} from '@/api/common';
import URL from '@/basUrl';

const actions = {
  getCalls: async (context, {
    vm,
    params,
    page = 1,
    loading = false
  }) => {
    await context.commit('SET_PAGE', page);
    await context.commit('CREATE_REQUEST_BODY', params);

    await sendCustomerRequest(URL.REPORT, JSON.stringify(params))
      .then((result) => {
        // vm.$bvToast.show('danger-toast'); - toast bootstrap показывает юзеру оповещение с ошибкой
        const status = [200, 401, 404];
        if (!status.includes(result.status)) {
          context.commit('notifications/SAVE_MESSAGE', JSON.parse(result.text).Error, {
            root: true
          });
          vm.$bvToast.show('danger-toast');
          return;
        }

        if (result.status === 200) {
          context.commit('SET_TABLE', JSON.parse(result.text));
        }

        context.commit('SHOW_LOADING_SPINNER', loading, { root: true });
      })
      .catch((e) => {
        console.error(e);
        context.commit('notifications/SAVE_MESSAGE', e, {
          root: true
        });
        vm.$bvToast.show('danger-toast');
      });

    if (!loading) context.commit('SHOW_LOADING', loading, { root: true });
  }
};

export default {
  actions
};
